import { render } from "./payment_type_tab.vue?vue&type=template&id=f2c85446"
import script from "./payment_type_tab.vue?vue&type=script&lang=js"
export * from "./payment_type_tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__